import React from 'react';
import { motion } from 'framer-motion';
import { Fireworks } from './Fireworks';
import { useCountdown } from '../hooks/useCountdown';
import { formatSchedule } from '../utils/schedule';
interface CountdownStageProps {
  eventName: string;
  startsAt: number;
  timeZone: string;
  /** Extra line under the clock, e.g. who is watching. */
  footnote?: string;
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  const text = String(value).padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-67" data-mp="1ess8kjf9t6b">
      <div className="relative overflow-hidden rounded-xl border border-line bg-surface/80 px-4 py-3 sm:px-6 sm:py-4" data-id="element-68" data-mp="1gnf44e97vd1">
        <motion.span key={text} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="block font-display text-[clamp(2.25rem,7vw,4.5rem)] leading-none tabular-nums text-white" data-id="element-69" data-mp="3jqz21w5dzghl">
          {text}
        </motion.span>
      </div>
      <span className="mt-2 text-[0.65rem] font-semibold uppercase tracking-[0.24em] text-muted" data-id="element-70" data-mp="3rovi9vi5us2r">
        {label}
      </span>
    </div>;
}
export function CountdownStage({
  eventName,
  startsAt,
  timeZone,
  footnote
}: CountdownStageProps) {
  const remaining = useCountdown(startsAt);
  const showDays = remaining.days > 0;
  return <div className="relative flex min-w-0 flex-1 flex-col items-center justify-center overflow-hidden px-5 py-16 text-center sm:px-10" data-id="element-71" data-mp="3vpp9oyutap0e">
      <Fireworks data-id="element-72" data-mp="3415aw0be2akw" />

      <div className="relative" data-id="element-73" data-mp="341nfplc49x4f">
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-gold" data-id="element-74" data-mp="33y9fojqxe005">
          Starting soon
        </p>
        <h2 className="mt-4 break-words font-display text-[clamp(2rem,6vw,3.75rem)] leading-tight text-white" data-id="element-75" data-mp="3d1ahw9co76yj">
          {eventName}
        </h2>

        <div className="mt-10 flex items-start justify-center gap-3 sm:gap-5" role="timer" aria-live="off" data-id="element-76" data-mp="2p9vc26loq7ij">
          {showDays && <Unit value={remaining.days} label="Days" data-id="element-77" data-mp="o9qhoox0v4lm" />}
          <Unit value={remaining.hours} label="Hours" data-id="element-78" data-mp="o749cn2b4l2c" />
          <Unit value={remaining.minutes} label="Minutes" data-id="element-79" data-mp="t7jkd7z49gh5" />
          <Unit value={remaining.seconds} label="Seconds" data-id="element-80" data-mp="t5ysxr83mdni" />
        </div>

        <p className="mt-9 text-sm text-body" data-id="element-81" data-mp="xzthp92k9itg">{formatSchedule(startsAt, timeZone)}</p>
        <p className="mt-1 text-xs text-muted" data-id="element-82" data-mp="12xl9m337h4xn">
          The draw begins automatically when the countdown reaches zero.
        </p>
        {footnote && <p className="mt-5 text-sm text-muted" data-id="element-83" data-mp="a9fq1jnw1lze">{footnote}</p>}
      </div>
    </div>;
}